import { useState } from 'react';

export default function useModalState<T>() {
  const [modalState, setModalState] = useState<'NONE' | T>('NONE');

  const handleOpenModal = (type: 'NONE' | T) => {
    setModalState(type);
  };
  const handleCloseModal = () => {
    setModalState('NONE');
  };
  const handleToggleModal = (type: 'NONE' | T) => {
    if (modalState === type) {
      handleCloseModal();
    } else {
      setModalState(type);
    }
  };

  return { modalState, handleOpenModal, handleCloseModal, handleToggleModal };
}
